var exports = {
  "mJ": "x127c5a35--1ccc67--reaction",
  "mj": "x127c5a35--1ccc67--like",
  "QZ": "x127c5a35--1ccc67--dislike",
};

module.exports = exports;
